var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{class:[
    'typo',
    _vm.themeClass
]},[_c('div',{directives:[{name:"bastards",rawName:"v-bastards"}]},[_vm._t("default")],2),(_vm.html)?_c('div',{directives:[{name:"bastards",rawName:"v-bastards"}],domProps:{"innerHTML":_vm._s(_vm.html)}}):_vm._e()])}
var staticRenderFns = []

export { render, staticRenderFns }